var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 100,
    viewBox: "0 0 158 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Imported Layers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.3 80.3H116A4.6 4.6 0 0 0 111 85v4.7a4.6 4.6 0 0 0 4.7 4.6h12.3a4.6 4.6 0 0 0 4.6-4.6V85a4.6 4.6 0 0 0-4.7-4.7zm.4 9.4a.4.4 0 0 1-.4.4H116a.4.4 0 0 1-.6-.3V85c0-.3.2-.4.5-.4h12.3c.2 0 .4 0 .4.4v4.7zm-21-5c-.2-.2-.4-.2-.5 0l-1.4 2.3a.6.6 0 0 0 0 .6l1.4 2.4h.4l1.4-2.4a.6.6 0 0 0 0-.6l-1.4-2.3m45-4.4h-17.2V100h4.2v-5.7h13a4.6 4.6 0 0 0 4.5-4.6V85a4.6 4.6 0 0 0-4.5-4.7zm.3 9.4a.4.4 0 0 1-.5.4h-13v-5.4h13c.2 0 .4 0 .4.4v4.7zM142.3 76h11.8a3 3 0 0 0 3-2.8V37.7h-14.8V76m-83 9v4.7a4.6 4.6 0 0 0 4.7 4.6h15.3V90H64a.4.4 0 0 1-.3-.3V85c0-.3 0-.4.4-.4h15.3v-4.3H64a4.6 4.6 0 0 0-4.6 4.7m49-9h28v-8H120v-7h16.4v-8.2H120v-7h16.4v-8h-31V73a3 3 0 0 0 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4 49.7V76h14.8V66h4.5l7 10H102l-8.4-12.4 5.8-5.8v-20H84.7L74.2 43v-3.8c0-.8-.7-1.5-1.6-1.5h-4L91.5 7 119 31.5l14-15.3 18 15.3h6L133 10.3 117 23.6 93.4 3l-3-2.8L41 49.4l-5.7-11.7H40L25.5 10.3 11.3 37.7h4.5L6.2 57h6L1 80.2l53.2 14-10.5-23.7 15.7-21zm14.8 1.7L84.7 46v11H74.2v-5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 80.3H86.4A4.6 4.6 0 0 0 82 85v4.7a4.6 4.6 0 0 0 4.5 4.6H99a4.6 4.6 0 0 0 4.5-4.6V85a4.6 4.6 0 0 0-4.6-4.7zm.3 9.4a.4.4 0 0 1-.4.4H86.4a.4.4 0 0 1-.4-.3V85c0-.3.3-.4.5-.4H99s.3 0 .3.4v4.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReiLogo);
export default __webpack_public_path__ + "static/media/rei-logo.6d6a4cc3d92a2ed9c11aa8724f5086c1.svg";
export { ForwardRef as ReactComponent };